import React, { useState, useEffect, useLayoutEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import PersonAdd from "@mui/icons-material/PersonAdd";
import Settings from "@mui/icons-material/Settings";
import Logout from "@mui/icons-material/Logout";
import ThemeToggle from "./ThemeToggle";
import "./NavMenu.css";

import { signOut } from "firebase/auth";
import { auth, db } from "../../../firebaseConfig.js";
import { doc, getDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";

export default function AccountMenu() {
  const navigate = useNavigate();
  const [signOutDialogOpen, setSignOutDialogOpen] = useState(false);

  const [colorMode, setColorMode] = useState(() => {
    const stored = localStorage.getItem("colorMode");
    return stored === "dark" ? "dark" : "light";
  });

  useLayoutEffect(() => {
    if (colorMode === "dark") {
      document.body.classList.add("dark-mode");
    } else {
      document.body.classList.remove("dark-mode");
    }
    localStorage.setItem("colorMode", colorMode);
  }, [colorMode]);

  useEffect(() => {
    const getColorMode = async () => {
      if (!auth.currentUser) return;
      const docRef = doc(db, "users", auth.currentUser.uid);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        const firestoreColorMode = data.colorMode === "dark" ? "dark" : "light";
        setColorMode(firestoreColorMode);
      }
    };
    getColorMode();
  }, []);

  const handleSignOutClick = () => setSignOutDialogOpen(true);
  const handleDialogClose = () => setSignOutDialogOpen(false);
  const handleSettingsClick = () => navigate("/settings");
  const handleAddAccountClick = () => navigate("/signup");

  const handleSignOut = () => {
    signOut(auth)
      .then(() => {
        console.log("Sign-out successful.");
        navigate("/");
      })
      .catch((error) => console.error("Sign-out error:", error));
  };
  
  // Wrapper for actions inside an anchor tag
  const handleActionClick = (action) => (e) => {
    e.preventDefault();
    action();
  }

  const absoluteMenuStyles = {
    position: 'absolute',
    bottom: '36px', // Position below icon
    // right: '0', // Adjust to align arrow
    // width: '232px',
    display: 'block',
    padding: '8px',
    // background: 'var(--Grey3)',
    // border: 'solid 1px var(--Grey4)',
    borderRadius: '16px',
    // filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
    paddingRight: '8px',
    // maringRight: '16px',
    // zIndex: 1400,
  };

  return (
    <div style={absoluteMenuStyles}>

          <ul className="nav-account-menu" >
              
            <li  className="nav-menu-item" >
              <a href="#" style={{ textDecoration: 'none' }}>
                <ThemeToggle colorMode={colorMode} setColorMode={setColorMode} />
              </a>
            </li>

            <li className="nav-menu-item">
              <a href="#" onClick={handleActionClick(handleAddAccountClick)}>
                <PersonAdd sx={{ color: "var(--Grey7)", verticalAlign: 'middle', margin: '0 8px 0 0px' }} fontSize="small" />
                <span style={{ color: "var(--Grey7)", verticalAlign: 'middle' }}>Invite a team member</span>
              </a>
            </li>
            <li className="nav-menu-item">
              <a href="#" onClick={handleActionClick(handleSettingsClick)}>
                <Settings sx={{ color: "var(--Grey7)", verticalAlign: 'middle', margin: '0 8px 0 0px' }} fontSize="small" />
                <span style={{ color: "var(--Grey7)",verticalAlign: 'middle' }}>Settings</span>
              </a>
            </li>
            <li className="nav-menu-item">
              <a href="#" onClick={handleActionClick(handleSignOutClick)}>
                <Logout sx={{ color: "var(--Grey7)", verticalAlign: 'middle', margin: '0 8px 0 0px' }} fontSize="small" />
                <span style={{ color: "var(--Grey7)", verticalAlign: 'middle' }}>Sign out</span>
              </a>
            </li>
          </ul>

      <div style={{ alignContent: "center", display: "flex", justifyContent: "center", borderRadius: "12px" }}>
          {/* <div style={{width:"44px", height: "44px", borderRadius: "100px"}}> */}
          <svg
            width="44px"
            height="44px"
            viewBox="0 0 44 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ cursor: "pointer", borderRadius: "100px" }}
          >
            <rect width="44" height="44" fill="#272A2C" />
            <path
              d="M11 12H14.9487C18.6872 12 21.7179 15.0021 21.7179 18.7053V25.0382C21.7179 28.7414 18.6872 31.7435 14.9487 31.7435H11V12Z"
              fill="#FF5C58"
            />
            <path d="M11 21.5897H15.5128V22.1538H11V21.5897Z" fill="#272A2C" />
            <path
              d="M32.9998 31.7435H29.0511C25.3126 31.7435 22.2819 28.7414 22.2819 25.0382V18.7054C22.2819 15.0021 25.3126 12 29.0511 12H32.9998V31.7435Z"
              fill="#FF5C58"
            />
            <path d="M27.9231 21.5897H33V22.1538H27.9231V21.5897Z" fill="#272A2C" />
            <path d="M19.4614 21.0258H24.5383V22.7181H19.4614V21.0258Z" fill="#FF5C58" />
          </svg>
          {/* </div> */}
      </div>

      <Dialog open={signOutDialogOpen} onClose={handleDialogClose}>
        <DialogTitle>Sign Out</DialogTitle>
        <DialogContent>
          Are you sure you want to sign out?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose}>Cancel</Button>
          <Button onClick={handleSignOut}>Sign Out</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}



